import { render, staticRenderFns } from "./signaturePopAttendee.vue?vue&type=template&id=0880d55b"
import script from "./signaturePopAttendee.vue?vue&type=script&lang=js"
export * from "./signaturePopAttendee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0880d55b')) {
      api.createRecord('0880d55b', component.options)
    } else {
      api.reload('0880d55b', component.options)
    }
    module.hot.accept("./signaturePopAttendee.vue?vue&type=template&id=0880d55b", function () {
      api.rerender('0880d55b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/tbm/signaturePopAttendee.vue"
export default component.exports